import { MonitoringOverview } from "@/features/oversight/monitoring";

export default function MonitoringPage() {
  return <MonitoringOverview />;
}
